/* @flow */

import type { CombinedReducers } from '../../../reducers';
import type { Dispatch } from '../../../types/types';
import type { NetgemApiEmitterType, RequestResponseMethodDefinitionType } from '../emitter';

import { REDUX_MSG_REQUEST_BO_STREAMS_GET } from '../../constants';
import getRequestDetails from './helpers/requestCommon';
import { BO_API_GET_STREAMS, type BO_RESPONSE_WITH_ETAG } from './types/common';

const sendGetStreamsRequest: (distributorId: string, signal?: AbortSignal) => RequestResponseMethodDefinitionType =
  (distributorId, signal) =>
  (dispatch: Dispatch, getState: () => CombinedReducers, NetgemApiEmitter: NetgemApiEmitterType): Promise<BO_RESPONSE_WITH_ETAG> => {
    // Object 'requestDetails' contains 'headers', 'method' and 'uri' parameters
    const requestDetails = getRequestDetails(getState, distributorId, BO_API_GET_STREAMS);

    return NetgemApiEmitter.emit(REDUX_MSG_REQUEST_BO_STREAMS_GET, {
      ...requestDetails,
      signal,
    }).then(({ response }: BO_RESPONSE_WITH_ETAG) => response);
  };

export default sendGetStreamsRequest;
